import { render, staticRenderFns } from "./DelayRecords.vue?vue&type=template&id=e07f6ad8&scoped=true"
import script from "./DelayRecords.vue?vue&type=script&lang=js"
export * from "./DelayRecords.vue?vue&type=script&lang=js"
import style0 from "./DelayRecords.vue?vue&type=style&index=0&id=e07f6ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07f6ad8",
  null
  
)

export default component.exports